import { useMutation, useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { getStockBalance } from '../../network/stockBalanceReport';
import { queryKeys } from '../../services/react-query/queryKeys';
import { getStockLedgerReport } from '../../network/stockLedgerReport';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getSearchApi } from '../../network/itemList';
import { getGeneraledgerReport } from '../../network/generaledgerReport';
import { getParties, getSalesInvoiceDetails } from '../../network/PaymentEntry';
import { getPurchaseRecieptDetails } from '../../network/purchaseReciept';
import {
  getDebitNote,
  getPurchaseInvoiceDetails,
} from '../../network/purchaseInvoice';
import { useParams } from 'react-router-dom';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const GeneraledgerReport = ({
  t,
  invoice,
  reciept,
  sales,
  payment,
  journal,
  note,
  credit,
}) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const {
    idInvoice,
    idReciept,
    idSales,
    idPayment,
    idJournal,
    idNote,
    idCreditNote,
  } = useParams();
  const [form] = Form.useForm();
  const [sourceData, setSourceData] = useState({
    from_date: dayjs().startOf('year').format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
    account: '',
    party: '',
    stock_uom: '',
    cost_center: '',
    voucher_no: '',
    include_default_book_entries: 0,
    include_dimensions: 0,
  });
  console.log(sourceData, 'sourceData');

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getGeneraledgerReport,
      currentLang,
      sourceData.from_date,
      sourceData.to_date,
      sourceData.account,
      sourceData.party,
      sourceData.stock_uom,
      sourceData.stock_uom,
      sourceData.cost_center,
      sourceData.include_default_book_entries,
      sourceData.include_dimensions,
      sourceData.voucher_no,
    ],
    queryFn: () =>
      getGeneraledgerReport({
        currentLang,
        companyName,
        from_date: sourceData.from_date,
        to_date: sourceData.to_date,
        account: sourceData.account,
        party: sourceData.party,
        stock_uom: sourceData.stock_uom,
        cost_center: sourceData.cost_center,
        include_default_book_entries: sourceData.include_default_book_entries,
        include_dimensions: sourceData.include_dimensions,
        voucher_no: sourceData.voucher_no,
      }),
  });
  const { mutate: onAddPaymentEntry, data: partiesData } = useMutation({
    mutationKey: [queryKeys.getParties],
    mutationFn: (id) => getParties(id),
    // onSuccess: () => {
    //   setLoadingParties(false);
    // },
    // onError: () => {
    //   setLoadingParties(false);
    // },
  });
  const { message } = App.useApp();
  const { data: Warehouse } = useQuery({
    queryKey: [queryKeys.getWarehouseSearch],
    queryFn: () => getSearchApi('Warehouse'),
    keepPreviousData: true,
  });
  // const { data: salesInvoice, isLoading: loadingSales } = useQuery({
  //   queryKey: [queryKeys.getSalesInvoiceDetails, idCreditNote],
  //   queryFn: () => getSalesInvoiceDetails(idCreditNote),
  //   keepPreviousData: true,
  //   enabled: !!credit,
  // });
  const { data: recieptDetails, isLoading: recieptLoading } = useQuery({
    queryKey: [queryKeys.getPurchaseReciept, idReciept],
    queryFn: () => getPurchaseRecieptDetails(idReciept),
    keepPreviousData: true,
    enabled: !!idReciept && reciept,
  });
  const { data: invoiceDetails, isLoading: invoiceLoading } = useQuery({
    queryKey: [queryKeys.getPurchaseInvoice, idInvoice],
    queryFn: () => getPurchaseInvoiceDetails(idInvoice),
    keepPreviousData: true,
    enabled: !!idInvoice && invoice,
  });
  const { data: debitNoteDetails, isLoading: LoadingNoteDetails } = useQuery({
    queryKey: [queryKeys.getDebitNote, idNote],
    queryFn: () => getDebitNote(idNote),
    enabled: !!note,
  });
  // const { data: salesInvoice, isLoading: loadingSales } = useQuery({
  //   queryKey: [queryKeys.getSalesInvoiceDetails, idSales],
  //   queryFn: () => getSalesInvoiceDetails(idSales),
  //   keepPreviousData: true,
  //   enabled: !!idSales && sales,
  // });
  const { data: account } = useQuery({
    queryKey: [queryKeys.getSearchApiAccount],
    queryFn: () => getSearchApi('Account'),
    keepPreviousData: true,
  });
  const { data: costCenters } = useQuery({
    queryKey: [queryKeys.getCostCentersSearch],
    queryFn: () => getSearchApi('Cost Center'),
    keepPreviousData: true,
  });
  useEffect(() => {
    if (reciept && recieptDetails) {
      form.setFieldsValue({
        voucher_no: idReciept,
      });
      setSourceData({
        ...sourceData,
        from_date: dayjs(recieptDetails?.data?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(recieptDetails?.data?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        voucher_no: idReciept,
      });
    }
  }, [recieptDetails, idReciept, reciept]);
  useEffect(() => {
    if (credit && idCreditNote) {
      form.setFieldsValue({
        voucher_no: idCreditNote,
      });
      setSourceData({
        ...sourceData,
        from_date: dayjs().format('YYYY-MM-DD'),
        to_date: dayjs().add(1, 'month').format('YYYY-MM-DD'),
        voucher_no: idCreditNote,
      });
    }
  }, [idCreditNote, credit]);
  useEffect(() => {
    if (note && idNote) {
      form.setFieldsValue({
        voucher_no: idNote,
      });
      setSourceData({
        ...sourceData,
        from_date: dayjs(debitNoteDetails?.message?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(debitNoteDetails?.message?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        voucher_no: idNote,
      });
    }
  }, [idNote, note]);
  useEffect(() => {
    if (sales && idSales) {
      form.setFieldsValue({
        voucher_no: idSales,
      });
      setSourceData({
        ...sourceData,
        voucher_no: idSales,
      });
    }
  }, [idSales, sales]);
  useEffect(() => {
    if (payment && idPayment) {
      form.setFieldsValue({
        voucher_no: idPayment,
      });
      setSourceData({
        ...sourceData,
        voucher_no: idPayment,
      });
    }
  }, [idPayment, payment]);
  useEffect(() => {
    if (journal && idJournal) {
      form.setFieldsValue({
        voucher_no: idJournal,
      });
      setSourceData({
        ...sourceData,
        voucher_no: idJournal,
      });
    }
  }, [idJournal, journal]);
  useEffect(() => {
    if (invoice && invoiceDetails) {
      // console.log(invoiceDetails,"invoiceDetails");
      form.setFieldsValue({
        voucher_no: idInvoice,
      });
      setSourceData({
        ...sourceData,
        from_date: dayjs(invoiceDetails?.data?.posting_date).format(
          'YYYY-MM-DD'
        ),
        to_date: dayjs(invoiceDetails?.data?.posting_date)
          .add(1, 'month')
          .format('YYYY-MM-DD'),
        voucher_no: idInvoice,
      });
    }
  }, [invoiceDetails, idInvoice, invoice]);
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));

  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );
  if (invoiceLoading || recieptLoading || LoadingNoteDetails) {
    return (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  // const totalRow = stockBalanceDetails?.message?.result?.slice(-1)[0];

  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.inventory} subTitle={t.GeneralLedger} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="mt-5">
        <Form name="basic" layout="vertical" form={form}>
          {/* <Flex 
        style={{  
          // justifyContent: 'space-between',
          gap: '20px',
          alignItems: 'center',
          marginBottom: '20px'
        }}
        > */}
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="date"
                // label={t.date}
              >
                <RangePicker
                  format="YYYY/MM/DD"
                  style={{ width: '100%' }}
                  value={[
                    dayjs(sourceData.from_date),
                    dayjs(sourceData.to_date),
                  ]}
                  placeholder={['From Date', 'To Date']}
                  defaultValue={[dayjs().startOf('year'), dayjs()]}
                  // defaultValue={[dayjs(), dayjs().add(1, 'month')]}
                  onChange={(dates, dateStrings) => {
                    setSourceData({
                      from_date: dateStrings[0],
                      to_date: dateStrings[1],
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="account"
                // label={t.Account}
              >
                <Select
                  placeholder={t.Account}
                  showSearch
                  allowClear
                  popupMatchSelectWidth={false}
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  // mode="multiple"
                  options={account?.message?.map((item) => ({
                    value: item?.value,
                    label: item?.value,
                  }))}
                  onChange={(value) => {
                    setSourceData({
                      ...sourceData,
                      account: `${value === undefined ? '[]' : `["${value}"]`}`,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="party_type"
                // label={t.PartyType}
              >
                <Select
                  placeholder={t.PartyType}
                  allowClear
                  onClear={() => {
                    setSourceData({
                      ...sourceData,
                      party_type: '',
                    });
                  }}
                  onChange={(value) => {
                    onAddPaymentEntry(value);
                  }}
                  options={[
                    { value: 'Customer', label: t.Customer },
                    { value: 'Supplier', label: t.Supplier },
                    { value: 'Employee', label: t.Employee },
                    { value: 'Shareholder', label: t.Shareholder },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="Party"
                // label={t.Party}
              >
                <Select
                  placeholder={t.Party}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  onChange={(value) => {
                    setSourceData({
                      ...sourceData,
                      party: `${value === undefined ? '[]' : `["${value}"]`}`,
                    });
                  }}
                  options={partiesData?.message?.parties?.map((user) => ({
                    value: user?.name,
                    label: user?.name,
                  }))}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={12} md={8} xl={6} xxl={6}>
              <Form.Item
            name="warehouse"
            // label={t.warehouse}
            >

        <Select
          placeholder={t.warehouse}
          showSearch
          popupMatchSelectWidth={false}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? '').toLocaleLowerCase().includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? '')
              .toLowerCase()
              .localeCompare((optionB?.label ?? '').toLowerCase())
          }
          options={Warehouse?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
          style={{ width: '100%' }}
          onChange={(value) => {
            setSourceData({
              ...sourceData,
              warehouse: `"${value}"`,
            });
          }}
        />
            </Form.Item>
            </Col> */}
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="cost_center"
                // label={t.costCenter}
              >
                <Select
                  placeholder={t.costCenter}
                  showSearch
                  allowClear
                  popupMatchSelectWidth={false}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  options={costCenters?.message?.map((item) => ({
                    value: item?.value,
                    label: item?.value,
                  }))}
                  onChange={(value) => {
                    setSourceData({
                      ...sourceData,
                      cost_center: `${
                        value === undefined ? '[]' : `["${value}"]`
                      }`,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={6}>
              <Form.Item
                name="voucher_no"
                // label={t.costCenter}
              >
                <Input
                  allowClear
                  // value={sourceData?.voucher_no}
                  placeholder={t.VoucherNo}
                  onChange={(value) => {
                    setSourceData({
                      ...sourceData,
                      voucher_no: value.target.value,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={12}
              xl={8}
              xxl={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
              }}
            >
              <Form.Item
                name="include_dimensions"
                label={t.includeDimensions}
                valuePropName="checked"
                layout="horizontal"
                // className='margin-bottom-0'
              >
                <Checkbox
                  onChange={(e) => {
                    setSourceData({
                      ...sourceData,
                      include_dimensions: e.target.checked ? 1 : 0,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              md={12}
              xl={8}
              xxl={6}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'start',
              }}
            >
              <Form.Item
                name="include_default_book_entries"
                label={t.includeDefaultBookEntries}
                valuePropName="checked"
                layout="horizontal"
                // className='margin-bottom-0'
              >
                <Checkbox
                  onChange={(e) => {
                    setSourceData({
                      ...sourceData,
                      include_default_book_entries: e.target.checked ? 1 : 0,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            {/* <h3>{t.StockBalanceList}</h3> */}
          </Row>
          {/* </Flex> */}
        </Form>
        <Divider orientation="left">{t.GeneralLedger}</Divider>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          // summary={() => (
          //   <Table.Summary.Row>
          //     {totalRow?.map((value, index) => (
          //       <Table.Summary.Cell key={index}>{value}</Table.Summary.Cell>
          //     ))}
          //   </Table.Summary.Row>
          // )}
        />
      </Card>
    </div>
  );
};

export default GeneraledgerReport;
